<template>
  <v-container>
    <p>
      Formularz rejestracyjny uczestnika projektu
      "MatChemFiz - podnoszenie kompetencji matematyczno-przyrodniczych oraz ICT u młodzieży szkolnej"
    </p>
    <p>Projekt nr POWR.03.01.00-00-T163/18, współfinansowany przez Unię Europejską ze środków Europejskiego Funduszu Społecznego w ramach Programu Operacyjnego Wiedza Edukacja Rozwój 2014-2020, Oś III. Szkolnictwo wyższe dla gospodarki i rozwoju, Działanie 3.1. Kompetencje w szkolnictwie wyższym.</p>

    <v-form ref="form" v-model="valid" lazy-validation>
      <fieldset>
        <legend>Zadanie:</legend>
        <v-radio-group v-model="excercise" required :rules="requiredFieldRule">
          <v-radio label="Zadanie 8: Chemiczne Staże Badawcze" value="chemiczne-staze-badawcze"></v-radio>
          <v-radio label="Zadanie 9: Szkoła Młodego Chemika" value="szkola-mlodego-chemika"></v-radio>
          <v-radio label="Zadanie 10: Open Lab" value="open-lab"></v-radio>
        </v-radio-group>
      </fieldset>

      <v-text-field v-model="name" label="Imię" required :rules="requiredFieldRule"></v-text-field>

      <v-text-field v-model="surname" label="Nazwisko" required :rules="requiredFieldRule"></v-text-field>

      <v-text-field v-model="pesel" label="PESEL" required :rules="requiredFieldRule"></v-text-field>

      <v-menu
        ref="birthDateMenu"
        v-model="birthDateMenu"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        min-width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="birthDate"
            label="Data urodzenia"
            prepend-icon="event"
            readonly
            v-bind="attrs"
            v-on="on"
            required
            :rules="requiredFieldRule"
          ></v-text-field>
        </template>
        <v-date-picker
          ref="picker"
          v-model="birthDateVal"
          :max="new Date().toISOString().substr(0, 10)"
          min="1950-01-01"
          first-day-of-week="1"
          locale="pl"
          @change="saveBirthDatePicker"
        ></v-date-picker>
      </v-menu>

      <v-text-field
        v-model="birthPlace"
        label="Miejsce urodzenia"
        required
        :rules="requiredFieldRule"
      ></v-text-field>

      <v-text-field v-model="schoolName" label="Szkoła" required :rules="requiredFieldRule"></v-text-field>

      <v-text-field v-model="schoolClass" label="Klasa" required :rules="requiredFieldRule"></v-text-field>

      <fieldset>
        <legend>Wykształcenie:</legend>
        <v-radio-group v-model="education" required :rules="requiredFieldRule">
          <v-radio label="niższe niż podstawowe (ISCED 0)" value="niższe niż podstawowe (ISCED 0)"></v-radio>
          <v-radio label="podstawowe (ISCED 1)" value="podstawowe (ISCED 1)"></v-radio>
          <v-radio label="gimnazjalne (ISCED 2)" value="gimnazjalne (ISCED 2)"></v-radio>
          <v-radio
            label="ponadgimnazjalne (ISCED 3) - dotyczy osób, które ukończyły: liceum, liceum
            profilowane, technikum, technikum uzupełniające, zasadniczą szkołę zawodową"
            value="ponadgimnazjalne (ISCED 3)"
          ></v-radio>
          <v-radio
            label="policealne (ISCED 4) - dotyczy osób, które ukończyły szkoły policealne"
            value="policealne (ISCED 4)"
          ></v-radio>
          <v-radio
            label="wyższe (ISCED 5-8) - dotyczy osób, które ukończyły uniwersytet, uniwersytet
            techniczny (politechnikę) lub inny ośrodek szkolnictwa wyższego"
            value="wyższe (ISCED 5-8)"
          ></v-radio>
        </v-radio-group>
      </fieldset>

      <v-text-field v-model="country" label="Kraj" required :rules="requiredFieldRule"></v-text-field>

      <v-text-field v-model="voivodeship" label="Województwo" required :rules="requiredFieldRule"></v-text-field>

      <v-text-field v-model="county" label="Powiat" required :rules="requiredFieldRule"></v-text-field>

      <v-text-field v-model="municipality" label="Gmina" required :rules="requiredFieldRule"></v-text-field>

      <v-text-field v-model="city" label="Miejscowość" required :rules="requiredFieldRule"></v-text-field>

      <v-text-field v-model="street" label="Ulica" required :rules="requiredFieldRule"></v-text-field>

      <v-text-field v-model="buildingNumber" label="Nr budynku" required :rules="requiredFieldRule"></v-text-field>

      <v-text-field v-model="apartmentNumber" label="Nr lokalu" required :rules="requiredFieldRule"></v-text-field>

      <v-text-field v-model="postalCode" label="Kod pocztowy" required :rules="requiredFieldRule"></v-text-field>

      <v-text-field
        v-model="contactPhone"
        label="Telefon kontaktowy"
        required
        :rules="requiredFieldRule"
      ></v-text-field>

      <v-text-field v-model="emailAddress" label="Adres email" required :rules="emailRules"></v-text-field>

      <v-text-field v-model="occupation" label="Zatrudniony w" required :rules="requiredFieldRule"></v-text-field>

      <fieldset>
        <legend>Osoba należąca do mniejszości narodowej lub etnicznej, migrant, osoba obcego pochodzenia</legend>
        <v-radio-group v-model="foreigner" required :rules="requiredFieldRule">
          <v-radio label="Nie" value="-1"></v-radio>
          <v-radio label="Odmowa podania informacji" value="0"></v-radio>
          <v-radio label="Tak" value="1"></v-radio>
        </v-radio-group>
      </fieldset>

      <fieldset>
        <legend>
          Osoba bezdomna lub dotknięta wykluczeniem z dostępu do mieszkań
          <sup>1</sup>
        </legend>
        <v-radio-group v-model="homeless" required :rules="requiredFieldRule">
          <v-radio label="Nie" value="-1"></v-radio>
          <v-radio label="Odmowa podania informacji" value="0"></v-radio>
          <v-radio label="Tak" value="1"></v-radio>
        </v-radio-group>
      </fieldset>

      <fieldset>
        <legend>Osoba z niepełnosprawnościami</legend>
        <v-radio-group v-model="disabled" required :rules="requiredFieldRule">
          <v-radio label="Nie" value="-1"></v-radio>
          <v-radio label="Odmowa podania informacji" value="0"></v-radio>
          <v-radio label="Tak" value="1"></v-radio>
        </v-radio-group>
      </fieldset>

      <div>
        <sup>1</sup> Bezdomność i wykluczenie mieszkaniowe definiowane są zgodnie z Europejską typologią bezdomności i
        wykluczenia mieszkaniowego ETHOS, w której wskazuje się okoliczności życia w bezdomności lub ekstremalne
        formy wykluczenia mieszkaniowego:
        <ol>
          <li>Bez dachu nad głową (osoby żyjące w surowych i alarmujących warunkach)</li>
          <li>
            Bez miejsca zamieszkania (osoby przebywające w schroniskach dla bezdomnych, w schroniskach dla kobiet,
            schroniskach dla imigrantów, osoby opuszczające instytucje penitencjarne/karne/szpitale, instytucje
            opiekuńcze, osoby otrzymujące długookresowe wsparcie z powodu bezdomności - specjalistyczne
            zakwaterowanie wspierane)
          </li>
          <li>
            Niezabezpieczone zakwaterowanie (osoby posiadające niepewny najem z nakazem eksmisji, osoby zagrożone
            przemocą)
          </li>
          <li>
            Nieodpowiednie warunki mieszkaniowe (konstrukcje tymczasowe, mieszkania substandardowe - lokale
            nienadające się do zamieszkania wg standardu krajowego, skrajne przeludnienie).
          </li>
        </ol>
      </div>
    </v-form>

    <div class="text-center">
      <v-btn class="nav-button" right @click="navigateNext">Dalej</v-btn>
    </div>
  </v-container>
</template>

<script>
import Vue from 'vue'

const axios = require("axios");

export default {
  data: () => ({
    valid: true,
    requiredFieldRule: [(v) => !!v || "Pole obowiązkowe"],
    emailRules: [
      (v) => !!v || "Email is required",
      (v) => /.+@.+/.test(v) || "E-mail must be valid",
    ],
    birthDateMenu: false,
    birthDateVal: null,
  }),
  watch: {
    birthDateMenu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
  },
  methods: {
    navigateNext() {
      this.valid = this.$refs.form.validate();

      if (this.valid) {
        this.submit();
      }
    },
    submit() {
      this.isNextDisabled = true;
      this.formUploading = true;
      axios
        .post("https://mfc.klatrat.org/participants/", this.$store.state, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          this.formUploading = false;
          Vue.rollbar.info(response);
          this.$router.push("/registration-confirmation");
        })
        .catch((error) => {
          this.formUploading = false;
          Vue.rollbar.error(error);
          this.$router.push("/registration-failed");
        });
    },
    saveBirthDatePicker(date) {
      this.$refs.birthDateMenu.save(date);
      this.$store.commit("setBirthDate", { birthDate: date });
    },
  },
  computed: {
    isNextDisabled() {
      return this.value != true;
    },
    excercise: {
      get() {
        return this.$store.state.excercise;
      },
      set(value) {
        this.$store.commit("setExcercise", { excercise: value });
      },
    },
    country: {
      get() {
        return this.$store.state.country;
      },
      set(value) {
        this.$store.commit("setCountry", { country: value });
      },
    },
    name: {
      get() {
        return this.$store.state.name;
      },
      set(value) {
        this.$store.commit("setName", { name: value });
      },
    },
    surname: {
      get() {
        return this.$store.state.surname;
      },
      set(value) {
        this.$store.commit("setSurname", { surname: value });
      },
    },
    pesel: {
      get() {
        return this.$store.state.pesel;
      },
      set(value) {
        this.$store.commit("setPesel", { pesel: value });
      },
    },
    birthDate: {
      get() {
        return this.birthDateVal;
      },
      set(value) {
        this.$store.commit("setBirthDate", { birthDate: value });
      },
    },
    birthPlace: {
      get() {
        return this.$store.state.birthPlace;
      },
      set(value) {
        this.$store.commit("setBirthPlace", { birthPlace: value });
      },
    },
    schoolName: {
      get() {
        return this.$store.state.schoolName;
      },
      set(value) {
        this.$store.commit("setSchoolName", { schoolName: value });
      },
    },
    schoolClass: {
      get() {
        return this.$store.state.schoolClass;
      },
      set(value) {
        this.$store.commit("setSchoolClass", { schoolClass: value });
      },
    },
    education: {
      get() {
        return this.$store.state.education;
      },
      set(value) {
        this.$store.commit("setEducation", { education: value });
      },
    },
    voivodeship: {
      get() {
        return this.$store.state.voivodeship;
      },
      set(value) {
        this.$store.commit("setVoivodeship", { voivodeship: value });
      },
    },
    county: {
      get() {
        return this.$store.state.county;
      },
      set(value) {
        this.$store.commit("setCounty", { county: value });
      },
    },
    municipality: {
      get() {
        return this.$store.state.municipality;
      },
      set(value) {
        this.$store.commit("setMunicipality", { municipality: value });
      },
    },
    city: {
      get() {
        return this.$store.state.city;
      },
      set(value) {
        this.$store.commit("setCity", { city: value });
      },
    },
    street: {
      get() {
        return this.$store.state.street;
      },
      set(value) {
        this.$store.commit("setStreet", { street: value });
      },
    },
    buildingNumber: {
      get() {
        return this.$store.state.buildingNumber;
      },
      set(value) {
        this.$store.commit("setBuildingNumber", { buildingNumber: value });
      },
    },
    apartmentNumber: {
      get() {
        return this.$store.state.apartmentNumber;
      },
      set(value) {
        this.$store.commit("setApartmentNumber", { apartmentNumber: value });
      },
    },
    postalCode: {
      get() {
        return this.$store.state.postalCode;
      },
      set(value) {
        this.$store.commit("setPostalCode", { postalCode: value });
      },
    },
    contactPhone: {
      get() {
        return this.$store.state.contactPhone;
      },
      set(value) {
        this.$store.commit("setContactPhone", { contactPhone: value });
      },
    },
    emailAddress: {
      get() {
        return this.$store.state.emailAddress;
      },
      set(value) {
        this.$store.commit("setEmailAddress", { emailAddress: value });
      },
    },
    occupation: {
      get() {
        return this.$store.state.occupation;
      },
      set(value) {
        this.$store.commit("setOccupation", { occupation: value });
      },
    },
    foreigner: {
      get() {
        return this.$store.state.foreigner;
      },
      set(value) {
        this.$store.commit("setForeigner", { foreigner: value });
      },
    },
    homeless: {
      get() {
        return this.$store.state.homeless;
      },
      set(value) {
        this.$store.commit("setHomeless", { homeless: value });
      },
    },
    disabled: {
      get() {
        return this.$store.state.disabled;
      },
      set(value) {
        this.$store.commit("setDisabled", { disabled: value });
      },
    },
  },
};
</script>

<style>
</style>
